import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { AdUnit } from 'features/inventory/types/adUnit'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'
import { AdUnitAlert } from '../types/adUnitAlert'

type Props = {
  alerts: AdUnit['alerts']
}

export const AdUnitAlerts = ({ alerts }: Props): JSX.Element => {
  const theme = useTheme()

  const UnpluggedAlert = (alert: Alert<AdUnitAlert>): AlertData => ({
    color: theme.palette.warning.main,
    Icon: (
      <SvgIcon
        component={UnpluggedIcon}
        inheritViewBox
      />
    ),
    tooltip: { text: alert.description },
  })

  const switcher = (alert: Alert<AdUnitAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'prebidStackEnabled':
        return UnpluggedAlert(alert)

      case 'priceGeniusEnabled':
        return UnpluggedAlert(alert)

      case 'refresherEnabled':
        return UnpluggedAlert(alert)

      case 'unfilledRecoveryEnabled':
        return UnpluggedAlert(alert)

      case 'viewabilityToolsEnabled':
        return UnpluggedAlert(alert)

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<AdUnitAlert> {...{ alerts, switcher }} />
}
